import styled from 'styled-components';

export const FloatButton = styled.div<{ $bottom?: number }>`
  position: fixed;
  bottom: ${(i) => i.$bottom ?? 76}px;
  z-index: 9;
  transition: all 0.3s ease-in-out;
  transform: translateX(calc(-100% - 8px));
`;
